import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'components';

function StackedStatBar(props) {
  var data = props.data,
      width = props.width,
      height = props.height;
  var valueTotal = data.reduce(function (acc, d) {
    return acc + Math.max(d.value, 0);
  }, 0);
  var dataWithWidths = data.map(function (d) {
    return _objectSpread(_objectSpread({}, d), {}, {
      showTooltip: false,
      width: Math.max(d.value, 0) / Math.max(valueTotal, 1) * 100
    });
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "row",
    style: {
      borderRadius: '2px',
      overflow: 'hidden',
      width: width,
      margin: 0
    }
  }, dataWithWidths.map(function (d, i) {
    return /*#__PURE__*/React.createElement(Stat, {
      data: data,
      key: i,
      datum: d,
      valueTotal: valueTotal,
      height: height
    });
  }));
}

StackedStatBar.defaultProps = {
  height: '30px',
  width: '150px'
};
StackedStatBar.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    color: PropTypes.string.isRequired
  }).isRequired).isRequired,
  width: PropTypes.string,
  // Expecting a CSS value, like '100px' or '50%'
  height: PropTypes.string
}; // Needed a class to hold the tooltip state for each section. Quick solution to an annoying problem.
// If this method becomes a perf. issue, can manage the tooltip state in the parent

var Stat = /*#__PURE__*/function (_Component) {
  _inherits(Stat, _Component);

  var _super = _createSuper(Stat);

  function Stat(props) {
    var _this;

    _classCallCheck(this, Stat);

    _this = _super.call(this, props);
    _this.state = {
      tooltipOpen: false
    };
    return _this;
  }

  _createClass(Stat, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          data = _this$props.data,
          datum = _this$props.datum,
          valueTotal = _this$props.valueTotal,
          height = _this$props.height;
      return /*#__PURE__*/React.createElement(Popover, {
        open: this.state.tooltipOpen,
        preferPlace: "above",
        content: /*#__PURE__*/React.createElement("div", {
          style: {
            padding: '3px',
            border: '1px solid #eee',
            borderRadius: '2px'
          }
        }, data.map(function (d, index) {
          return /*#__PURE__*/React.createElement("div", {
            style: d.name === datum.name ? {
              fontWeight: 'bold'
            } : {},
            key: index
          }, "".concat(d.name, ": ").concat(d.value));
        }))
      }, /*#__PURE__*/React.createElement("div", {
        onMouseEnter: function onMouseEnter() {
          return _this2.setState({
            tooltipOpen: true
          });
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.setState({
            tooltipOpen: false
          });
        },
        style: {
          minWidth: "".concat(Math.max(datum.width, valueTotal === 0 ? 1 : 0), "%"),
          maxWidth: "".concat(Math.max(datum.width, valueTotal === 0 ? 1 : 0), "%"),
          backgroundColor: datum.color,
          height: height
        }
      }));
    }
  }]);

  return Stat;
}(Component);

Stat.propTypes = {
  datum: PropTypes.object,
  valueTotal: PropTypes.number,
  height: PropTypes.string
};
export default StackedStatBar;